import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import Table from "../../../ui-components/table/table";
import ProbillPreview from "../../common/probill-preview/probillPreview";
import XGSNavLink from "../../../ui-components/xgs-nav-link/xgsNavLink";
import { DeliveredNoPodAnalysis, DeliveredNoPodProbill } from "app/data/terminal-insights/models";

interface PodDetailsProps {
  data: {
    summary: DeliveredNoPodAnalysis;
    description: string[];
  };
}

const podColumnHelper = createColumnHelper<DeliveredNoPodProbill>();

const PodDetails: React.FC<PodDetailsProps> = ({ data }) => {
  // POD table columns
  const podColumns = [
    podColumnHelper.accessor("probill", {
      id: "probill",
      header: "Probill",
      cell: (cellProps) => (
        <ProbillPreview probillNumber={Number(cellProps.getValue())}>
          <span>
            <XGSNavLink
              className="xgs-table-link-cell"
              to={`/shipments/${cellProps.getValue()}`}
              target="__blank"
            >
              {cellProps.getValue()}
            </XGSNavLink>
          </span>
        </ProbillPreview>
      ),
      size: 90
    }),
    podColumnHelper.accessor("delivered_date", {
      id: "delivered_date",
      header: "Delivered",
      cell: (cellProps) => moment(cellProps.getValue()).format('MMM DD'),
      size: 70
    }),
    podColumnHelper.accessor("age_days", {
      id: "age_days",
      header: "Age",
      cell: (cellProps) => `${cellProps.getValue()}d`,
      size: 50
    }),
    podColumnHelper.accessor("destination_terminal", {
      id: "destination_terminal",
      header: "Term",
      size: 40
    })
  ];

  return (
    <div className="pod-details">
      <div className="pod-details__stats">
        <span>Total probills without POD: <strong>{data.summary.total_probills}</strong></span>
        <span>Average age: <strong>{Math.round(data.summary.average_age_days)} days</strong></span>
      </div>
      <div className="pod-details__table">
        <Table
          sorting
          columns={podColumns}
          data={data.summary.probills}
          responsive
          enableRowSelection={false}
          noResultsText="No POD data available"
          infiniteScroll
          minTableHeight={320}
          maxTableWidth={1110}
        />
      </div>
    </div>
  );
};

export default PodDetails;
